@if ((abilities.viewOffers && abilities.viewCandidates) || abilities.manageCandidates) {
  <rt-activity-subscriptions-table [types]="types" [title]="title">
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        [title]="'app.subscriptions.events_group.job_candidate_hired' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['jobCandidateHired']"
        icon="hired"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="assignment-turned-in"
        [title]="'app.subscriptions.events_group.candidate_questionnaire_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['interviewRequestedResultAdd']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (gdprSvc.gdprSettingEnabled && abilities.manageCandidates) {
      <rt-activity-subscriptions-table-row
        [title]="'app.subscriptions.events_group.job_expiring_candidates_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        (changeEvents)="changeEvents.emit($event)"
        [eventsGroup]="['jobExpiringCandidates']"
        icon="gdpr-candidate"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (gdprSvc.gdprSettingEnabled && abilities.manageCandidates) {
      <rt-activity-subscriptions-table-row
        icon="gdpr-candidate"
        [title]="'app.subscriptions.events_group.gdpr_request_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['gdprRequestAdd']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="assignment-turned-in"
        [title]="'app.subscriptions.events_group.task_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['taskAdd', 'taskComplete', 'taskRemove']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="label"
        [title]="'app.subscriptions.events_group.candidate_tags_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['candidateTags', 'candidateTagsRemove', 'jobTags', 'jobTagsRemove']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="chat"
        [title]="'app.subscriptions.events_group.job_note_add_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'jobNoteAdd',
          'jobNoteRemove',
          'candidateNoteAdd',
          'candidateNoteRemove',
          'shareNoteAdd',
        ]"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="attach-file"
        [title]="'app.subscriptions.events_group.job_attachment_upload_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'jobAttachmentUpload',
          'jobAttachmentRemove',
          'candidateAttachmentUpload',
          'candidateAttachmentRemove',
          'shareAttachmentUpload',
        ]"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="forward"
        [title]="'app.subscriptions.events_group.candidate_stage_change_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['candidateStageChange']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="thumbs-up-down"
        [title]="'app.subscriptions.events_group.candidate_evaluation_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['interviewResultAdd', 'interviewResultRequestsAdd', 'shareResultAdd']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="add"
        [title]="'app.subscriptions.events_group.candidate_offer_assign_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['candidateOfferAssign', 'candidateOfferRemove']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="calendar-today"
        [title]="'app.subscriptions.events_group.candidate_meeting_create_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'interviewEventScheduled',
          'interviewEventRescheduled',
          'interviewEventRescheduledByCandidate',
          'interviewEventDeleted',
          'interviewRequestedEventAdd',
          'interviewEventCandidateRsvpChanged',
          'interviewEventRsvpChanged',
        ]"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="block"
        [title]="'app.subscriptions.events_group.candidate_disqualify_v2' | translate"
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="['candidateDisqualify', 'candidateRequalify', 'candidateAutoDisqualify']"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
    @if (abilities.viewOffers && abilities.viewCandidates) {
      <rt-activity-subscriptions-table-row
        icon="bookmark"
        [title]="
          (hasRequisitions && abilities.viewRequisitions
            ? 'app.subscriptions.events_group.job_follower_add_v3'
            : 'app.subscriptions.events_group.job_follower_add_v2'
          ) | translate
        "
        [activitySubscriptions]="activitySubscriptions"
        [types]="types"
        [eventsGroup]="[
          'jobFollowerAdd',
          'jobFollowerRemove',
          'candidateFollowerAdd',
          'candidateFollowerRemove',
          'requisitionFollowerAdd',
          'requisitionFollowerRemove',
        ]"
        (changeEvents)="changeEvents.emit($event)"
      >
      </rt-activity-subscriptions-table-row>
    }
  </rt-activity-subscriptions-table>
}
